<template>
  <div class="TabPage">
    <MainPageHeader/>
    <div v-if="tab" class="content">
      <header>
        <router-link class="back-button" :to="{ name: 'staticPage' }">
          <font-awesome-icon icon="arrow-left"/>
          <p class="font-size-middle">Wyjdź ze sklepu</p>
        </router-link>
        <h1 class="font-size-big">{{ tab.name }}</h1>
      </header>
      <div class="divider"/>
      <h1 class="text-header font-size-big">
        Do czego służy <strong>Vocale Concerto®</strong>?
      </h1>
      <section class="section-1">
        <div class="info font-size-middle">
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Sed id leo neque. Phasellus non nunc mattis, pharetra lacus nec,
            facilisis sapien. Fusce lectus.
          <ul>
            <li>Lorem ipsum dolor sit libero.</li>
            <li>Lorem ipsum dolor sit libero.</li>
            <li>Lorem ipsum dolor sit libero.</li>
          </ul>

          Lorem ipsum dolor sit amet, consectetur adipiscing elit. In nec consequat nunc.
          Proin libero tortor, consectetur ut turpis in duis.
          </p>
          <div class="image-placeholder"/>
        </div>
        <div class="image">
          <div class="image-placeholder"/>
        </div>
      </section>
      <div class="divider"/>
      <h1 class="text-header font-size-big" v-if="successor">
        Sprawdź również <strong>{{ successor.name }}</strong>
      </h1>
      <section class="section-2 font-size-middle" v-if="successor">
        <!--                                <strong>{{description.name}}</strong>-->

        <p>
          Sprawdź również PAKIET Vocale GoldSprawdź również PAKIET Vocale GoldSprawdź również Vocale Tab10
          roSprawdź również PAKIET Vocale GoldSprawdź również PAKIET Vocale GoldSprawdź również Vocale Tab10
          ProSprawdź również PAKIET Vocale Gold
        </p>
        <BigButton class="big-button" borderColor="primary" @click="route({
                    name: 'tabPage', params: { 'tabKey': successor.key }
                })">SPRAWDŹ
        </BigButton>
      </section>
      <div class="divider"/>
      <InfoSection/>
    </div>
    <TabFooter v-if="tab" :tab="tab" @buttonClicked="route({
                name: 'summaryPage',
                params: { 'tabKey': tab.key },
            })"/>
    <PageNotFound v-if="loadError" :message="loadError"/>
    <ContentLoader v-if="!tab"/>
  </div>
</template>

<script>
import MainPageHeader from '../components/MainPageHeader.vue';
import PageNotFound from '../components/PageNotFound.vue';
import ContentLoader from '../components/ContentLoader.vue';
import TabFooter from '../components/TabFooter.vue';
import BigButton from '../components/input/BigButton.vue';
import InfoSection from '../components/infosection/InfoSection.vue';
import { getTabService } from '../services/tabService';

export default {
  name: 'TabPage',
  components: {
    MainPageHeader,
    PageNotFound,
    ContentLoader,
    TabFooter,
    BigButton,
    InfoSection,
  },

  data() {
    return {
      tab: null,
      successor: null,
      loadError: null,
      description: null,
    };
  },

  mounted() {
    (async () => {
      this.tab = await getTabService().getTab(this.$route.params.tabKey);

      if (this.tab === null) {
        this.loadError = `The tab with the specified key doesn't exist`;
      } else {
        if (this.tab.successor) {
          this.successor = await getTabService().getTab(this.tab.successor);
        }
      }
    })();
  },

  methods: {
    route(location) {
      this.$router.push(location);
    }
  },

  beforeRouteUpdate(to, from, next) {
    this.tab = null;
    this.loadError = null;

    (async () => {
      this.tab = await getTabService().getTab(to.params.tabKey);

      if (this.tab === null) {
        this.loadError = `The tab with the specified key doesn't exist`;
      } else {
        if (this.tab.successor) {
          this.successor = await getTabService().getTab(this.tab.successor);
        } else {
          this.successor = null;
        }
      }

      next();
    })();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.TabPage {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr auto;
  grid-template-areas: 'header'
            'content'
            'footer';
  min-height: 100vh;
}

.MainPageHeader {
  grid-area: header;
}

.Footer {
  grid-area: footer;
}

.content {
  grid-area: content;

  padding: 0 20px;
  margin-top: 0px;

  header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 auto;
    max-width: 1300px;

    .back-button {
      display: flex;
      align-items: center;
      padding: 10px;
      color: white;
      background-color: transparent;
      border-radius: 3px;
      text-decoration: none;

      p {
        display: inline-block;
        margin: 0;
        margin-left: 0.7em;
      }
    }

    h1 {
      margin-left: 50px;
      color: $primary;
    }
  }

  .text-header {
    padding: 20px 0;
    text-align: center;
    color: white;

    strong {
      color: $primary;
    }
  }

  .section-1 {
    display: flex;
    justify-content: center;
    padding: 0 0;
    margin-bottom: 40px;
    color: white;

    .image {
      flex: 1 1;

      display: flex;
      justify-content: flex-end;
      margin-left: 50px;
      max-width: 500px;

      .image-placeholder {
        width: 360px;
        height: 360px;
        background-color: white;
      }
    }

    .info {
      flex: 1 1;
      max-width: 500px;

      .image-placeholder {
        margin: 70px 0 40px 0;
        width: 160px;
        height: 40px;
        background-color: white;
      }
    }
  }

  .section-2 {
    margin: 0 auto;
    max-width: 1200px;
    color: #ccc;

    .big-button {
      display: block;
      margin: 30px auto;
    }
  }

  .divider {
    border-bottom: 1px solid #aaa;
  }
}

// Mobile style
@media (max-width: $phone-max-width) {
  .content {
    h1 {
      text-align: center;
    }

    .section-1 {
      margin: 0;
      padding: 0;
      flex-direction: column-reverse;
      align-items: center;
      text-align: center;

      h1 {
        margin: 30px 0;
      }

      .image {
        margin: 20px 0 50px 0;

        .image-placeholder {
          width: 500px;
          max-width: 80vw;
        }
      }
    }

    .section-tab {
      margin: 50px 0;
      flex-direction: column;
      align-items: center;

      h1 {
        margin: 0px 0 00px 0;
      }

      .info {
        text-align: center;

        .image-placeholder {
          margin: 20px auto;
          width: 500px;
          max-width: 80vw;
        }

        .indented {
          margin: 0;
          margin-top: 30px;
        }
      }

      .image {
        margin: 0px 0 0px 0;

        .image-placeholder {
          width: 500px;
          max-width: 80vw;
        }
      }

      .buttons {
        display: flex;
        flex-direction: column-reverse;

        .mini-button {
          color: white;
          margin: 10px 0;
          padding: 10px 30px;
          border: 1px solid white;
          text-align: center;
        }
      }
    }
  }
}
</style>
